<template>
  <iStyledCard
    :author-name="`${collaborator.name}`"
    width="hug"
    :author-description="snakeToTitle(collaborator.role)"
    :author-avatar="avatar"
  />
</template>

<script>
import { DEFAULT_USER_AVATAR } from "%/constants/user-constants";
import { snakeToTitle } from "@vcl";
export default {
  name: "PublicationCollaboratorCardSmall",
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    collaborator() {
      return this.entity;
    },
    avatar() {
      return this.collaborator.avatar || DEFAULT_USER_AVATAR;
    },
  },
  methods: {
    snakeToTitle,
  },
};
</script>

<!-- eslint-disable-next-line -->
<style scoped lang="scss">
.i-card {
  overflow: visible;
}
</style>

<!-- eslint-disable-next-line -->
<style>
.card-author-name-text {
  white-space: nowrap;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-author-info {
  gap: 0px !important;
}
</style>
